.strip {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 0.4rem;
}

.segment {
  flex: 1 1 0;
  min-height: 0;
}
